import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1>GDG Management + Marketing Task</h1>
      <p>Get to know about the event planned</p>
    </header>
  );
}

export default Header;
